function num(value) {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
}

/** 배분이 어떻게 정해졌는지. auto_single은 컨테이너 1대라 전량, auto_pl은 PL 라인의 컨테이너 번호대로 서버가 확정 시 배분한 것이다. */
export const ALLOCATION_SOURCE = {
    auto_single: { label: 'Auto · Single', short: 'auto', title: 'Allocated automatically: this HBL has a single container' },
    auto_pl: { label: 'Auto · PL', short: 'auto (PL)', title: 'Allocated automatically from the container number on the PL line' },
    manual: { label: 'Manual', short: '', title: 'Allocated by a user' },
};

/** 한 라인에서 아직 컨테이너에 실리지 않은 수량. 컬럼으로 두지 않고 매번 계산한다. */
export function remainingQty(item, allocations) {
    const allocated = (allocations[item.id] ?? []).reduce((acc, a) => acc + num(a.alloc_qty), 0);
    return num(item.qty) - allocated;
}

/** 미배분 수량이 남은 라인만 고른다. 배지와 좌측 패널이 이 목록을 쓴다. */
export function unallocatedItems(items, allocations) {
    return items.filter((item) => remainingQty(item, allocations) > 0);
}

/** 분할 입력값이 라인 수량을 넘으면 저장을 막는다. */
export function splitExceedsQty(item, splitByContainer) {
    const total = Object.values(splitByContainer).reduce((acc, v) => acc + num(v), 0);
    return total > num(item.qty);
}

/** 컨테이너 번호 비교용. PL에는 공백·하이픈을 섞어 적는 경우가 있다. */
export const normalizeContainerNo = (value) => String(value ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');

/**
 * 라인을 어느 컨테이너에 실을지 PL이 알려주는 번호. 라인에 적힌 번호가 우선이고, 없으면 그 PL 하단에 적힌 번호 목록을 쓴다.
 * fromLine이 false면 문서 단위 번호라 라인별 배정은 아니다.
 */
export function containerHints(item, documentHints = {}) {
    if (item.cntr_hint) return { numbers: [item.cntr_hint], fromLine: true };
    return { numbers: documentHints[item.packing_list_id] ?? [], fromLine: false };
}

export const hintsContainer = (hints, container) => hints.numbers.some((n) => normalizeContainerNo(n) === normalizeContainerNo(container.cntr_number));
